var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecapUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.481,
    height: 21.481,
    viewBox: "0 0 21.481 21.481",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_21600",
    "data-name": "Tracciato 21600",
    d: "M15.448,20.1c.034,0,.062-.01.1-.012a7.414,7.414,0,0,1,5.578,2.683A9.158,9.158,0,0,1,9.771,22.7a7.432,7.432,0,0,1,5.53-2.611c.037,0,.075.012.111.012Zm-3.081-4.612a3.063,3.063,0,1,1,3.18,3.072c-.044,0-.088-.009-.132-.009s-.075.007-.114.009a3.053,3.053,0,0,1-2.934-3.072M6.293,15.5a9.209,9.209,0,1,1,15.96,6.239,8.946,8.946,0,0,0-3.928-2.685,4.587,4.587,0,1,0-7.489-3.527,4.547,4.547,0,0,0,1.689,3.52,8.945,8.945,0,0,0-3.866,2.6A9.135,9.135,0,0,1,6.293,15.5m-1.532,0A10.741,10.741,0,1,0,15.5,4.761,10.671,10.671,0,0,0,4.761,15.5",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_13196",
    "data-name": "Raggruppa 13196",
    transform: "translate(-4.761 -4.761)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_13195",
    "data-name": "Raggruppa 13195",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_4263",
    "data-name": "Rettangolo 4263",
    width: 30.876,
    height: 30.876,
    transform: "translate(0.064 0.063)",
    fill: "#221e20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_4264",
    "data-name": "Rettangolo 4264",
    width: 31.003,
    height: 31.003,
    transform: "translate(0 0)",
    fill: "#951a33"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecapUserIcon);
export default __webpack_public_path__ + "static/media/recap-user-icon.8a614c09112b18a9c1b63243d15e9c73.svg";
export { ForwardRef as ReactComponent };